// @ts-nocheck
import React, {useContext} from "react";
import {ResponsiveBar} from "@nivo/bar";
import ChartCard from "./ChartCard";
import StyleContext from "../../../contexts/StyleContext";
import {biggestUpsets} from "../data/fifaData";
import {FIFA_PALETTE, getNivoTheme} from "./chartTheme";

// 4.8 Biggest upsets (horizontal bar): largest rank-gap upsets where the
// higher-ranked team lost. Top 10 for readability.

const TOP_N = 10;

const capitalize = value => value.charAt(0).toUpperCase() + value.slice(1);

// Data is sorted by gap desc; Nivo renders the first datum at the bottom, so
// reverse the slice to put the largest gap on top.
const data = biggestUpsets.slice(0, TOP_N).reverse();

const UpsetTooltip = ({value, data: raw}) => (
  <div className="fifa-tooltip">
    <span className="fifa-tooltip__title">{raw.match}</span>
    <span className="fifa-tooltip__row">
      <span>Rank gap</span>
      <span>{value}</span>
    </span>
    <span className="fifa-tooltip__row">
      <span>Year</span>
      <span>{raw.year}</span>
    </span>
    <span className="fifa-tooltip__row">
      <span>Stage</span>
      <span>{capitalize(raw.stage)}</span>
    </span>
  </div>
);

export default function BiggestUpsets() {
  const {isDark} = useContext(StyleContext);

  const footnote = (
    <span className="fifa-legend">
      <span className="fifa-legend__note">
        Top {TOP_N} largest rank-gap upsets.
      </span>
    </span>
  );

  return (
    <ChartCard
      title="Biggest upsets"
      takeaway="The largest ranking upset: South Africa (83) beat France (9)"
      footnote={footnote}
    >
      <ResponsiveBar
        data={data}
        keys={["gap"]}
        indexBy="match"
        layout="horizontal"
        margin={{top: 10, right: 24, bottom: 48, left: 250}}
        padding={0.3}
        valueScale={{type: "linear"}}
        colors={[FIFA_PALETTE.accent]}
        borderRadius={3}
        enableLabel={true}
        label={d => d.value}
        labelTextColor="#ffffff"
        axisBottom={{
          legend: "Rank gap",
          legendPosition: "middle",
          legendOffset: 40
        }}
        axisLeft={{tickSize: 0, tickPadding: 8}}
        enableGridX={true}
        enableGridY={false}
        tooltip={UpsetTooltip}
        theme={getNivoTheme(isDark)}
        animate={true}
        motionConfig="gentle"
        role="img"
      />
    </ChartCard>
  );
}
